<template>
  <section class="login">
    <div class="container">
      <div class="row justify-content-md-center mb-2">
        <div>
          <img
            width="100%"
            src="@/assets/svg/Ardunic Account page-111.svg"
            alt="login"
          />
        </div>
      </div>
      <div class="row justify-content-md-center">
        <!-- <div class="col col-lg-4">
          <div class="login-card">
            <div >
              <div class="input">
                <input type="text" v-model="signup.name" placeholder="User Name" />
              </div>
              <div class="input">
                <input type="text" v-model="signup.phone" placeholder="Phone Number" />
              </div>
              <div class="input">
                <input type="text" v-model="signup.email" placeholder="Email" />
              </div>
              <div class="input">
                <input type="text" v-model="signup.password" placeholder="Password" />
              </div>
              <div class="input-b">
                <button @click="signUp">Sign up</button>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col col-lg-4">
          <div class="login-card">
            <div
              style="margin-top: 70px"
              action
              class="justify-content-md-center"
            >
              Your Phone Number is
              <span style="font-weight: bold">{{ phone }}</span>
              <div class="input">
                <input type="text" v-model="code" placeholder="Password" />
              </div>
              <div class="input-b">
                <button @click="activateAccount" class="login-b">
                  Activate
                </button>
                <a @click="resendCode">Resend activation link</a>
              </div>
              <p style="color: red; margin-top: 20px" v-if="error">
                {{ error }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
// import Swal from 'sweetalert2'

export default {
  props: ["phone", "reCaptchaToken"],
  data() {
    return {
      // phone: "07817479706",
      code: "",
      error: null,
      resendMsg: "",
    };
  },
  methods: {
    resendCode() {
      axios
        .post("https://api.ardunic.com/v1/resend_code", {
          phone: this.phone,
          action: "activation",
          reCaptchaToken: this.reCaptchaToken,
        })
        .then((res) => {
          if (res.data.success == true) {
            this.resendMsg = "the activation code has been sent to your mobile";
            alert(this.resendMsg);
          } else {
            this.resendMsg = "Error";
            alert(this.resendMsg);
          }
        });
    },
    activateAccount() {
      axios
        .post("https://api.ardunic.com/v1/user_activation", {
          phone: this.phone,
          code: this.code,
        })
        .then((res) => {
          this.resendMsg =
            "Your account has been activated you can login now enjoy :))";
          alert(this.resendMsg);
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 1000);
        })
        .catch((error) => {
          if (!error.response.data.success) {
            this.error = error.response.data.message;
          }
        });
    },
  },
};
</script>

<style scoped>
.login {
  margin-top: 90px;
}

.circle {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 50%;
}

.type1 {
  width: 120px;
  height: 120px;
  border: none;
}

::placeholder {
  color: #2a2a2a;
}

.login-card {
  border: 1px solid #2a2a2a;
  width: 100%;
  height: 290px;
  border-radius: 20px;
  text-align: center;
}

.input {
  border: 1px solid #2a2a2a;
  margin: 10px 30px;
  border-radius: 20px;
  height: 40px;
  color: #2a2a2a;
}

.input-b {
  border: none;
  margin: 10px 30px;
  border-radius: 20px;
  height: 40px;
}
.input-b .login-b {
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(to right, #46ad68, #05f040);
  color: white;
  border: none;
}
form {
  margin-top: 20px;
}

.input input {
  border: none;
  text-align: center;
  height: 100%;
}

.input-b button {
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(to right, #05cefc, #5659ce);
  color: white;
  border: none;
}
</style>
